import { HttpClient } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Client } from 'app/entities';
import { cpfOrCnpj, emailAddress } from 'app/helpers/validators';
import { ClientsService } from 'app/main/pages/clients/clients.service';
import { AlertService } from 'app/services/alert.service';
import { CnpjAutocompleteService } from 'app/services/cnpj-autocomplete.service';
import { SubscriptionRestrictionService } from 'app/services/subscription-restriction.service';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-form-client-create-or-edit',
  templateUrl: './form-client-create-or-edit.component.html',
  styleUrls: ['./form-client-create-or-edit.component.scss']
})


export class FormClientCreateOrEditComponent implements OnInit, OnDestroy {

  @Input('client') client?: Client;
  /** ORCA-1922: só nome e WhatsApp à vista; o resto fica em "Mais dados". */
  @Input() compact = false;
  /** Nome inicial no cadastro (ex.: o termo buscado no seletor de clientes). */
  @Input() initialName?: string;
  showMore = false;
  @ViewChild('nomeInput') nomeInput?: any;
  @Output() onCreatedClient = new Subject<Client>();


  loading = false;
  form?: FormGroup
  private cnpjAutocompleteSubscription?: Subscription;

  constructor(
    private _formBuilder: FormBuilder,
    private _httpService: HttpClient,
    private _alertService: AlertService,
    private _clientService: ClientsService,
    private _cnpjAutocompleteService: CnpjAutocompleteService,
    private _subscriptionRestrictionService: SubscriptionRestrictionService
  ) { }

  ngOnInit(): void {
    this.createForm();
  }

  ngOnDestroy(): void {
    this.cnpjAutocompleteSubscription?.unsubscribe();
  }

  createForm() {
    console.log('form-client-create-or-edit create form');

    this.form = this._formBuilder.group({
      name: [this.client?.name ?? this.initialName ?? null, [Validators.required]],
      cpf_cnpj: [this.client?.cpfCnpj, [cpfOrCnpj()]],
      state_registration: [this.client?.stateRegistration, []],
      municipal_registration: [this.client?.municipalRegistration, []],
      responsible: [this.client?.responsible, []],
      email: [this.client?.email, [emailAddress()]],
      phone: [this.client?.phone, []],
      cep: [this.client?.cep, []],
      address: [this.client?.address, []],
      address_number: [this.client?.addressNumber, []],
      address_city: [this.client?.addressCity, []],
      address_state: [this.client?.addressState, []],
      address_neighborhood: [this.client?.addressNeighborhood, []],
      address_complement: [this.client?.addressComplement, []]
    });

    // Só no cadastro: na página do cliente (edição), o foco abria o teclado do celular ao carregar
    if (!this.client) {
      setTimeout(() => {
        this.nomeInput?.nativeElement.focus();
      }, 100);
    }

    this.cnpjAutocompleteSubscription?.unsubscribe();
    this.cnpjAutocompleteSubscription = this._cnpjAutocompleteService.watchForm(this.form, 'cpf_cnpj', {
      name: 'razao_social',
      responsible: 'nome_fantasia',
      email: 'email',
      phone: data => data.ddd_telefone_1 || data.ddd_telefone_2 || data.ddd_fax,
      cep: 'cep',
      address: 'logradouro',
      address_number: 'numero',
      address_city: 'municipio',
      address_state: 'uf',
      address_neighborhood: 'bairro',
      address_complement: 'complemento'
    });
  }

  store() {
    if (this.form?.valid) {
      this.loading = true
      this._clientService.store(this.formValue()).subscribe((res) => {
        this._alertService.success('Cliente criado');
        this.onCreatedClient.next(res)
        this.loading = false
        this.form?.reset()
        this._subscriptionRestrictionService.reloadSubscriptionUsages()
      }, (error) => {
        this._alertService.error(error)
        this.loading = false
      })
    }
  }

  update() {
    if (this.form?.valid && this.client) {
      this.loading = true
      this._clientService.update(this.client?.id, this.formValue()).subscribe((res) => {
        this._alertService.success('Cliente atualizado');
        this.form?.markAsPristine()
        this.loading = false
      }, (error) => {
        this.loading = false
        this._alertService.error(error)
      })
    }
  }

  private formValue() {
    const value = this.form?.value ?? {};
    // Inscrições vazias vão como '' (o FormData ignora null), senão a API não consegue limpar o valor
    return {
      ...value,
      email: value.email?.trim() || value.email,
      state_registration: value.state_registration ?? '',
      municipal_registration: value.municipal_registration ?? '',
    };
  }

  changeAddressByCep() {
    if (this.loading) {
      return;
    }
    if (this.form?.value?.cep && this.form?.value?.cep != this.client?.cep) {
      this._httpService.get(`https://viacep.com.br/ws/${this.form?.value?.cep}/json/`).subscribe((res) => {
        let address: any = res;
        this.form?.patchValue({
          address: address.logradouro,
          address_city: address.localidade,
          address_state: address.uf,
          address_complement: address.complemento,
          address_neighborhood: address.bairro
        });
      }, (error) => {
        // this._alertService.error('Erro ao localizar o endeço atravez do CEP')
      })
    }
  }

}
